module.exports = __webpack_public_path__ + "static/media/30OIOS5.fe7afe95.jpg";